import * as core from '../../../../../../../core'
import * as employeePlanning from '../employee-planning'

export const RESOURCE = {
  payload: {
    alias: 'engagements',
    appAlias: employeePlanning.RESOURCE.payload.alias,
    description:
      'Explore an employee-role-project assignments within an organization.',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Engagements',
    page: { alias: 'engagements' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
